import { type ProductBySlugExtendedResponse } from '@/modules/product/aliases';

/*
 * Builds the "what" search query param to be used to perform a search
 * based on the properties of an existing product
 * e.g. Mens nike jumper size medium black
 */
export function buildFallbackSearchQuery({
  productExtended,
}: {
  productExtended?: ProductBySlugExtendedResponse;
}) {
  const { brand, gender, colour, product_type_name } =
    productExtended?.attributes || {};

  const parts = [];

  if (gender) {
    parts.push(gender);
  }
  if (brand?.name) {
    parts.push(brand.name);
  }
  if (product_type_name) {
    parts.push(product_type_name);
  }
  if (productExtended?.sizes?.[0]?.name) {
    parts.push(`size ${productExtended.sizes[0].name}`);
  }
  if (colour?.[0]?.name) {
    parts.push(colour[0].name);
  }

  return parts.join(' ');
}
